var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('n-form-item',{staticClass:"v-textarea",attrs:{"title":_vm.title}},[_c('wysiwyg',{attrs:{"html":_vm.value},on:{"html":_vm.input}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }